import { useTw } from '../../../../../../../../../utils/Styles'
import { shortenString } from '../../../../../../../../../utils'

type AttachmentPreviewProps = { url: string; name: string }
export function AttachmentPreview({ url, name }: AttachmentPreviewProps) {
  const tw = useTw()
  return <img src={url} className={tw`h-16 w-16 object-cover`} alt={name} />
}

export function AttachmentName({ name }: { name: string }) {
  const tw = useTw()
  return (
    <span
      className={tw`text-sm leading-none text-neutral-400 font-bold text-center whitespace-nowrap pl-3`}
    >
      {shortenString(name)}
    </span>
  )
}
